var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 29.5H25.4V23.2009C25.4 21.4729 24.6377 20.5088 23.2706 20.5088C21.7829 20.5088 20.9 21.5134 20.9 23.2009V29.5H17.3V17.8H20.9V19.1157C20.9 19.1157 22.0295 17.1338 24.5747 17.1338C27.1208 17.1338 29 18.6875 29 21.9023V29.5ZM13.1978 15.9288C11.9837 15.9288 11 14.9371 11 13.714C11 12.4918 11.9837 11.5 13.1978 11.5C14.411 11.5 15.3947 12.4918 15.3947 13.714C15.3956 14.9371 14.411 15.9288 13.1978 15.9288ZM11 29.5H15.5V17.8H11V29.5Z",
    fill: "#082832"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedin);
export default __webpack_public_path__ + "static/media/footer-linkedin.2a31a414055625e204f1db1c42683dc3.svg";
export { ForwardRef as ReactComponent };